import {useEffect, useState} from 'react';
import {mrbgStore} from "./mrbgRedux";

function MrbgDataList(){


  const [myDatalist,setMyDatalist] = useState(mrbgStore.getState().mrbgVars.datalist||{});

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setMyDatalist(mrbgStore.getState().mrbgVars.datalist||{});
    })
    return () =>unsubscribe();
  })

  return(
    Object.keys(myDatalist).map((id,k)=>{
      return(
        <datalist id={id} key={k}>
          {
            myDatalist[id].map((val,i)=>{
              return <option value={val} key={i}/>
            })
          }
        </datalist>
      )
    })
  )
}

export default MrbgDataList;